import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';

import { ButtonText } from '../buttons';

/**
 * FlatButton base component.
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const FlatButton = ({ text, bgColor, mt, mb, mr, ml, ...props }) => {
    const ButtonWrapper = styled.div`
        display: inline-flex;
        margin-top: ${props => mt ? props.theme.space[mt] : 'inherit'}; 
        margin-bottom: ${props => mb ? props.theme.space[mb] : 'inherit'}; 
        margin-left: ${props => ml ? props.theme.space[ml] : 'inherit'}; 
        margin-right: ${props => mr ? props.theme.space[mr] : 'inherit'};

        & .stolo-button-flat {
            color: ${props => props.theme.palette.primary[800]};
            font-weight: normal;
            padding: ${props => props.theme.space[6]};
            background-color: ${bgColor};
        }
`;

    return (
        <ButtonWrapper>
            <Button {...props} classes={{ root: 'stolo-button-flat' }} component='div' >
                <ButtonText buttonText={text} />
            </Button>
        </ButtonWrapper>
    );
};

export default FlatButton;



// WEBPACK FOOTER //
// ./src/components/buttons/ColoredFlatButton.js